import { createSelector } from 'reselect';
import moment from 'moment';

import getBuffer from './getBuffer';
import getCurrentOrder from './getCurrentOrder';

const getDeliveryTimeFetchedEstimate = createSelector(
  [getCurrentOrder],
  order => {
    if (order.deliveryTimeFetchedEstimate) {
      return moment(order.deliveryTimeFetchedEstimate).format();
    }

    return null;
  },
);

export default getDeliveryTimeFetchedEstimate;

export const $getDeliveryTimeFetchedEstimate = createSelector(
  [getDeliveryTimeFetchedEstimate, getBuffer],
  (deliveryTimeFetchedEstimate, buffer) => {
    if (buffer.deliveryTimeFetchedEstimate) {
      return moment(buffer.deliveryTimeFetchedEstimate).format();
    }

    return deliveryTimeFetchedEstimate;
  },
);
